<template>
    <section class="showcase sk-bg-color">
    <div class="p-0 sk-card">
        <div class="col-lg-12 order-lg-1 showcase-text sk-title-color">
          <h3>SUKIMATCHの</h3>
          <h1 class="lead mb-0">ご利用の流れ</h1>
        </div>

      <!-- Content Row -->
    <div class="row">
      <div class="col-md-6 mb-5">
        <div class="card h-100">
          <div class="card-body">
            <h2 class="card-title">1. 無料会員登録</h2>
            <p class="card-text number">まずはアプリをダウンロードし会員登録</p>
          </div>
        </div>
      </div>
      <!-- /.col-md-4 -->
      <div class="col-md-6 mb-5">
        <div class="card h-100">
          <div class="card-body">
            <h2 class="card-title">2. 希望に合ったクリエイターを探す</h2>
            <p class="card-text">お客様のご要望に合ったクリエイターを探します</p>
          </div>
        </div>
      </div>
      </div>

      <div class="row">
      <div class="col-md-6 mb-5">
        <div class="card h-100">
          <div class="card-body">
            <h2 class="card-title">3. バナーの発注</h2>
            <p class="card-text">出品されているバナーからクリエイターに発注します</p>
          </div>
        </div>
      </div>
      <!-- /.col-md-4 -->
      <div class="col-md-6 mb-5">
        <div class="card h-100">
          <div class="card-body">
            <h2 class="card-title">4. 打ち合わせ</h2>
            <p class="card-text">作業の詳細などを直接クリエイターと打ち合わせます</p>
          </div>
        </div>
      </div>
      </div>

      <div class="row">
      <div class="col-md-6 mb-5">
        <div class="card h-100">
          <div class="card-body">
            <h2 class="card-title">5. 納品</h2>
            <p class="card-text">完成したバナーデータを受け取ります</p>
          </div>
        </div>
      </div>
      <!-- /.col-md-4 -->
      <div class="col-md-6 mb-5">
        <div class="card h-100">
          <div class="card-body">
            <h2 class="card-title">6. 評価・フィードバック</h2>
            <p class="card-text">クリエイターに対して評価やフィードバックをお願いいたします</p>
          </div>
        </div>
      </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
    
}
</script>

<style>
.sk-bg-color{
    background-color: #f18b02;
}

.sk-card {
    margin-top: 20px;
    margin-right: 20px;
    margin-left: 20px;
}

div.card-body {
    border-radius: 0;
}

/* h2 {
    font-size: ;
} */

.sk-title-color {
    color: #ffffff;
}
</style>